import axios from "axios";
import services from "@/utils/services";

function obtenerHeaders(session) {
  if (!session || !session.exists()) {
    throw new Error(
      "La sesión no está disponible"
    );
  }

  const jwt = session.get("jwt");

  if (!jwt) {
    throw new Error(
      "El token de sesión no está disponible"
    );
  }

  return {
    Authorization: "Bearer " + jwt,
  };
}

export async function listarExportacionesProgramadas(
  session,
  opciones = {}
) {
  const response = await axios.get(
    services.routes
      .exportacionesProgramadas,
    {
      headers:
        obtenerHeaders(session),
      params: {
        incluir_inactivas:
          opciones.incluirInactivas !==
          false,
      },
    }
  );

  return response.data;
}

export async function listarConexionesOneDrive(
  session
) {
  const response = await axios.get(
    services.routes
      .conexionesOneDriveExportaciones,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}

export async function listarGrupos(
  session
) {
  const response = await axios.get(
    services.routes.grupos,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  const resultado =
    response.data || {};

  if (!resultado.correcto) {
    throw new Error(
      resultado.mensaje ||
      "No fue posible consultar los grupos"
    );
  }

  const datos =
    resultado.grupos ||
    resultado.data?.grupos ||
    resultado.data?.items ||
    resultado.data ||
    resultado.resultados ||
    [];

  return Array.isArray(datos)
    ? datos
    : [];
}

export async function listarCatalogosExportaciones(
  session
) {
  const [
    grupos,
    conexionesResultado,
  ] = await Promise.all([
    listarGrupos(session),
    listarConexionesOneDrive(session),
  ]);

  if (!conexionesResultado.correcto) {
    throw new Error(
      conexionesResultado.mensaje ||
      "No fue posible consultar OneDrive"
    );
  }

  return {
    grupos,
    conexiones:
      Array.isArray(
        conexionesResultado.conexiones
      )
        ? conexionesResultado.conexiones
        : [],
  };
}

export async function crearExportacionProgramada(
  session,
  datos
) {
  const response = await axios.post(
    services.routes
      .exportacionesProgramadas,
    datos,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}


export async function actualizarExportacionProgramada(
  session,
  codigo,
  datos
) {
  const response = await axios.put(
    `${services.routes.exportacionesProgramadas}/${codigo}`,
    datos,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}


export async function cambiarEstadoExportacionProgramada(
  session,
  codigo,
  activo
) {
  const response = await axios.post(
    `${services.routes.exportacionesProgramadas}/${codigo}/estado`,
    {
      activo,
    },
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}

export async function eliminarExportacionProgramada(
  session,
  codigo
) {
  const response = await axios.delete(
    `${services.routes.exportacionesProgramadas}/${codigo}`,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}


export async function listarHistorialExportacion(
  session,
  codigo
) {
  const response = await axios.get(
    `${services.routes.exportacionesProgramadas}/${codigo}/historial`,
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}


export async function ejecutarExportacionProgramada(
  session,
  codigo
) {
  const response = await axios.post(
    `${services.routes.exportacionesProgramadas}/${codigo}/ejecutar`,
    {},
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}

export async function obtenerVistaPreviaExportacionProgramada(
  session,
  codigo
) {
  const response = await axios.post(
    `${services.routes.exportacionesProgramadas}/${codigo}/vista-previa`,
    {},
    {
      headers:
        obtenerHeaders(session),
    }
  );

  return response.data;
}
